import { Reveal } from "./Reveal";

export const ArtOrigin = () => (
  <section id="origin" data-testid="art-origin" className="relative py-28 md:py-44 border-t border-bds-border">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-6">
          <Reveal>
            <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">The Origin</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-display font-light text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] mt-6">
              It didn&apos;t start<br />with clothing.
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="font-serif-display italic font-light text-3xl md:text-5xl text-bds-muted mt-6 md:mt-10">
              It started here.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="font-grotesk text-base md:text-lg text-bds-muted leading-relaxed max-w-md mt-10 md:mt-14">
              Paper. Graphite. The hours no one sees. Every Black Dog Society work
              begins as a drawing made when talking wasn&apos;t possible.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-6 grid grid-cols-12 gap-4 md:gap-6">
          <Reveal className="col-span-7">
            <img
              src="/story/black-dog-society-artist-hands-drawing.webp"
              alt="The artist's hands drawing with graphite in the Black Dog Society studio"
              loading="lazy"
              width="848"
              height="1264"
              className="w-full h-auto object-cover grayscale"
            />
          </Reveal>
          <Reveal delay={0.1} className="col-span-5 md:mt-24">
            <img
              src="/story/black-dog-society-graphite-sketch-macro.webp"
              alt="Macro fragment of graphite strokes on textured paper"
              loading="lazy"
              width="1264"
              height="848"
              className="w-full aspect-[4/5] object-cover grayscale"
            />
            <p className="font-mono-bds text-[10px] uppercase tracking-[0.3em] text-bds-muted mt-4">
              Studio — Wellington, NZ
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
